<div class="scanner-create-modal">
  <h2 class="scanner-create-modal__title">
    {{ 'monitoring.scanner.new' | translate }}
  </h2>

  <form
    class="scanner-create-modal__form"
    [formGroup]="createScanForm"
    (ngSubmit)="submit()"
  >
    <div class="scanner-create-modal__filters">
      <mon-facility-select
        class="scanner-create-modal__filter"
        formControlName="facilityId"
        [fullWidth]="true"
        labelTranslateKey="monitoring.scanner.facility"
      />

      <lib-input
        class="scanner-create-modal__filter"
        [formControl]="containerSearchControl"
        [placeholder]="'monitoring.search' | translate"
      >
        <lib-svg-icon
          class="suffix"
          icon="minimalistic-magnifer"
          [size]="20"
        />
      </lib-input>
    </div>

    <mon-container-selector
      [facilityId]="currentFacilityId()"
      [keyword]="containerSearchControl.value"
      formControlName="containersId"
    />

    <div class="scanner-create-modal__actions">
      <lib-button
        buttonType="submit"
        buttonSize="large"
        [disabled]="createScanForm.invalid"
      >
        {{ 'monitoring.scanner.new-scan.submit' | translate }}
      </lib-button>
    </div>
  </form>
</div>
